/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for UserRenewals.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SD_EXTERNALUSER_RENEWAL_STATUS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `USERRENEWALS/FETCH_SD_EXTERNALUSER_RENEWAL_STATUS`
);

const FETCH_SD_RENEWAL_APPLICATION_FORM = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `USERRENEWALS/FETCH_SD_RENEWAL_APPLICATION_FORM`
);

const FETCH_SDCCA_CCA_RENEWAL_APPLICATION_FORM = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `USERRENEWALS/FETCH_SDCCA_CCA_RENEWAL_APPLICATION_FORM`
);

export {
  FETCH_SD_EXTERNALUSER_RENEWAL_STATUS,
  FETCH_SD_RENEWAL_APPLICATION_FORM,
  FETCH_SDCCA_CCA_RENEWAL_APPLICATION_FORM,
};
